import UsuarioService from "@/common/services/usuario/usuario.service";
import AprovacaoService from "@/common/services/usuario/aprovacao.service";
import AlertaService from '@/common/services/alerta/alerta.service';
import helpers from "@/common/utils/helpers";
import EmpresasService from "@/common/services/empresas/empresas.service";
export function fetchSizeUsersToAprove({commit}){
    AprovacaoService.listar('Aguardando',0, 0).then(response => {
        commit('setSizeUsersToAprove', response.data.data.itens.length);
    });
}

export function decodeUser({commit}){
    commit('setUser', localStorage.getItem('usuario_token'));
}

export function fetchUserData({commit, dispatch}){
    /*let token =localStorage.getItem('usuario_token');
    if(!token)
        return false
    let user = jwt_decode(token);

    UsuarioService.buscarPorId(user.nameid).then(response => {
        commit('setUserInfo', response.data.data);
    });*/

    UsuarioService.me().then(response => {
        commit('setUserInfo', response.data.data);
        dispatch('buscarPermissoes');
    });
}

export function buscarPermissoes({commit,state}){
    UsuarioService.buscarPermissoes(state.userInfo.id).then(res => {
        commit('adicionarPermissao', res.data.data);
    });
}

export function buscarAlertas({commit,state}){
    commit('setAlertas', []);
    let idUsuario = state.userInfo ? state.userInfo.id : null;
    if(idUsuario == null)
        return;
    AlertaService.listarPendentes(idUsuario).then(response => {
        let alertas = response.data.data.map(alerta => {
            alerta.corpo = helpers.pegarCorpo(alerta.mensagem);
            alerta.titulo = helpers.pegarTitulo(alerta.mensagem);
            return alerta;
        });

        commit('setAlertas', alertas);
    });
}

export function buscarEmpresas({commit}){
    commit('setListaEmpresas', []);
    EmpresasService.listar().then((res) => {
        commit("setListaEmpresas", res.data.data.itens);
    });
}